<div mat-dialog-content>
  <mat-form-field>
    <mat-label>API URL</mat-label>
    <input matInput type="text" [(ngModel)]="data.url">
  </mat-form-field>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button mat-button [mat-dialog-close]="data.url" cdkFocusInitial>Ok</button>
  </div>
</div>
